module.exports = __webpack_public_path__ + "static/img/team.6acce508.png";